import defaultV2Client from '@/plugins/axios/defaultV2Client'

export default {
  getDepositName(uuid = '') {
    const query = uuid.length > 0 ? `wholesalerAccountUuid=${uuid}` : ''
    return defaultV2Client.get(`/payments/deposit-name?${query}`)
  },

  getDelayMinutes() {
    return defaultV2Client.get('/payments/delay')
  },
}
